import React from 'react';
import './styles.scss';
import FormUpdateDistributorUser from '../molecules/configuration/users/editUser';
import { useHistory } from 'react-router-dom';
import FormCreateDistributorUser from '../molecules/configuration/users/createUser';

const FormUser: React.FC = () => {
  const history = useHistory();
  const path = history.location.pathname;

  return (
    <>
      {path.includes('edit') ? (
        <FormUpdateDistributorUser />
      ) : (
        <FormCreateDistributorUser />
      )}
    </>
  );
};

export default FormUser;
